<template>
  <div
    class="home-wrapper"
    v-if="activityData"
    :style="{ 'background-color': activityData.bgColor || '#fff' }"
  >
    <div class="apply-top">
      <div class="banner">
        <img :src="activityData.image" alt="" />
        <span class="rule-btn" v-if="activityData.isRuleHidden" @click="goRule">活动规则</span>
      </div>
      <h3 class="title" v-if="!activityData.isRuleHidden">{{ activityData.title }}</h3>
      <div class="desc" v-if="!activityData.isRuleHidden" v-html="activityData.desc"></div>
      <!-- <div class="apply-info" v-if="activityData.time || activityData.address">
        <p class="time">
          <span class="icon iconfont">&#xe784;</span
          ><b>{{ activityData.time }}</b>
        </p>
        <p class="adress">
          <span class="icon iconfont">&#xe790;</span
          ><b>{{ activityData.address }}</b>
        </p>
      </div> -->
    </div>
    <div class="apply-wrap">
      <!-- <h4 class="apply-title">
        {{ aid !== "60f8ffe07563cb0049a9cc07" ? "报名信息" : "求助信息" }}
      </h4> -->
      <div
        class="apply-item"
        v-for="(item, index) in formField"
        :key="index"
      >
        <label for=""><span v-if="item.isMust">*</span>{{ item.name }}</label>
        <div class="apply-field">
          <!-- 单选 -->
          <div class="radio-wrapper" v-if="item.type == 'radio'">
            <label v-for="(opt, optIdx) in item.option" :key="optIdx"
              ><input
                type="radio"
                :name="item.field"
                :data-required="item.isMust"
                :value="opt"
              />&nbsp;{{ opt }}</label
            >
          </div>
          <!-- 多选 -->
          <div class="checkbox-wrapper" v-else-if="item.type == 'checkbox'">
            <label v-for="(opt, optIdx) in item.option" :key="optIdx"
              ><input
                type="checkbox"
                :name="item.field"
                :data-required="item.isMust"
                :value="opt"
              />&nbsp;{{ opt }}</label
            >
          </div>
          <!-- 文本域 -->
          <textarea
            class="apply-field-type apply-field-textarea"
            v-else-if="item.type == 'textarea' || item.type == 'html'"
            :name="item.field"
            :data-required="item.isMust"
            :style="item.type == 'html' ? 'height: 10rem' : ''"
             @focus="keyboardShow" @blur="keyboardHidden"
          ></textarea>
          <!-- 下拉框 -->
          <div class="select-wrapper" v-else-if="item.type == 'select'">
            <select
              class="apply-field-type apply-field-select"
              :name="item.field"
              :data-required="item.isMust"
            >
              <option
                v-for="(opt, optIdx) in item.option"
                :value="opt"
                :key="optIdx"
              >
                {{ opt }}
              </option>
            </select>
            <span class="icon iconfont">&#xe8ec;</span>
          </div>
          <!-- 上传 -->
          <div class="apply-upload" v-else-if="item.type == 'image' || item.type == 'video' || item.type == 'file'">
            <upload-component :type="item.type" :field="item.field" :required="item.isMust" :maxlen="item.maxLen || 1" @dialogDataEvent="setDialogData"></upload-component>
          </div>
          <!-- 省市区 -->
          <div class="city-wrapper" v-else-if="item.type == 'area'">
            <select class="apply-field-type" v-model="provinceValue" @change="handleProvince">
              <option v-for="(opt, optIdx) in provinceData" :value="opt.value" :key="optIdx">
                {{ opt.value }}
              </option>
            </select>
            <select class="apply-field-type" v-model="cityValue" @change="handleCity">
              <option v-for="(opt, optIdx) in cityData" :value="opt.value" :key="optIdx">
                {{ opt.value }}
              </option>
            </select>
            <select class="apply-field-type" v-model="areaValue">
              <option v-for="(opt, optIdx) in areaData" :value="opt.value" :key="optIdx">
                {{ opt.value }}
              </option>
            </select>
          </div>
          <!-- 可以增删的文本框 -->
          <div class="input-wrapper" v-else-if="item.type == 'array'">
                <div class="item" v-for="(inputItem, inputIndex) in item.list" :key="'item_' + inputIndex">
                    <input
                        class="apply-field-type"
                        type="text"
                        :data-required="item.isMust"
                        v-model="inputItem.value"
                         @focus="keyboardShow" @blur="keyboardHidden"
                    />
                    <div class="icon iconfont remove" @click="removeInput(item, inputIndex)" v-if="!item.maxLen || item.maxLen > 1" v-show="!(item.list.length == 1 && inputIndex === 0)">&#xe780;</div>
                    <div class="icon iconfont add" @click="addInput(item, inputIndex)" v-if="!item.maxLen || item.maxLen > 1">&#xe781;</div>
                </div>        
          </div>
          <!-- 文本框 -->
          <input
            class="apply-field-type"
            v-else
            type="text"
            :name="item.field"
            :data-required="item.isMust"
             @focus="keyboardShow" @blur="keyboardHidden"
          />
        </div>
      </div>
      <button class="apply-submit-btn" @click="submit" :disabled="btnDisabled">
        立即提交
      </button>
    </div>
    <router-link
      to="/list"
      class="apply-my"
      v-if="userinfo && userinfo.token && activityData.isVerify"
      >我的<br />上传</router-link
    >
    <dialog-component @loginEvent="getUserInfo"></dialog-component>
  </div>
</template>

<script>
import COVER from "@/utils/COVER";
import axios from 'axios';
import UploadComponent from "@/components/Upload";
import DialogComponent from "@/components/Dialog";
import COVERAPP from "@/utils/COVERAPP";

import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "Home",
  data() {
    return {
      btnDisabled: false,
      formData: {},
      hasphone: false, //表单是否有phone字段
      cityData: [],
      provinceData: [],
      areaData: [],
      provinceValue: '四川省',
      cityValue: '',
      areaValue: '',
      formField: [],
      oriH: 0
    };
  },
  props: ["activityData"],
  computed: {
    ...mapState(["dialogData", "userinfo", "aid"]),
  },
  components: {
    UploadComponent,
    DialogComponent,
  },
  watch: {
    btnDisabled(v) {
      this.setPageLoadingAsync(v);
    },
  },
  created() {
    if (this.activityData.field && this.activityData.field.length) {
      let formField = JSON.parse(JSON.stringify(this.activityData.field))
        formField.forEach((val) => {
            if (val.field === "phone") {
                this.hasphone = true;
            }

            if (val.type === 'area') {
                this.getCityData();
            }
            if (val.type === 'array') {
                val.list = [{
                    value: ''
                }]
            }
            return val
        });
        this.formField = JSON.parse(JSON.stringify(formField))
    }
  },
  mounted() {
    this.oriH = document.documentElement.clientHeight || document.body.clientHeight
    if (COVERAPP.Attribute.isApp() || !this.activityData.isAppShow) {
      this.getUserInfo();
    }

    setTimeout(() => {
      this.setPageLoadingAsync(false);
    }, 500);
  },
  methods: {
    ...mapActions(["setPageLoadingAsync", "setDialogDataAsync"]),
    ...mapMutations(["setUserinfo"]),
    getUserInfo() {
      let _this = this;
      if (COVERAPP.Attribute.isApp()) {
        let isLoad_Bridging = setInterval(() => {
          try {
            COVERAPP.Method.GetUser({
              callback(res) {
                clearInterval(isLoad_Bridging);
                let userinfo = JSON.parse(res);
                if (!COVER.isEmpty(userinfo.user_id)) {
                  userinfo.origin = "app";
                  _this.setUserinfo(userinfo);
                  sessionStorage.setItem(
                    "COVER_USERINFO",
                    JSON.stringify(userinfo)
                  );
                }
              },
            });
          } catch (e) {}
        }, 300);
      } else {
        COVER.getUser((res) => {
          _this.setUserinfo(JSON.parse(JSON.stringify(res)));
        });
      }
    },
    submit() {
      if (!this.userinfo || (!this.userinfo.token && !this.hasphone)) {
        this.setDialogDataAsync({
          message: "参与活动，需登录!",
          btns: [
            {
              text: "去登录",
              className: "login-btn",
            },
            {
              text: "取消",
              className: "close-btn",
            },
          ],
        });
        return;
      }
      if (this.btnDisabled) return;
      this.btnDisabled = true;

      if (this.validateForm()) {
        if (this.hasphone && !this.formData.phone) {
          this.setDialogDataAsync({
            message: "参与活动，需填写手机号！",
            btns: [
              {
                text: "确认",
              },
            ],
          });
          return;
        }
        this.setDialogDataAsync(null);
        const token = this.userinfo.token || this.formData.phone;
        COVER.$post("/apply", {
          info: this.formData,
          token: `${token}`,
          userinfo: this.userinfo,
          aid: this.aid,
        })
          .then((ret) => {
            setTimeout(() => {
              this.btnDisabled = false;
            }, 1000);
            if (ret.errno == 0) {
              this.setDialogDataAsync({
                message:
                  this.aid == "620b7b44d355f50055632bc1"
                    ? "信息已提交，请等待通知。"
                    : "提交成功!",
                btns: [
                  {
                    text: "确认",
                    className: "reload-btn",
                  },
                ],
              });
            } else {
              let msg = "";
              if (ret.errno == 1004) {
                msg = "重复提交";
              } else if (ret.errno == 1001) {
                msg = "尚未开始";
              } else if (ret.errno == 1002) {
                msg = "已结束";
              } else {
                msg = "参与失败," + ret.errmsg;
              }
              this.setDialogDataAsync({
                message: msg,
                btns: [
                  {
                    text: "确认",
                  },
                ],
              });
              return false;
            }
          })
          .catch((err) => {
            setTimeout(() => {
              this.btnDisabled = false;
            }, 1000);
            this.setDialogDataAsync({
              message: err.message || "提交失败",
              btns: [
                {
                  text: "确认",
                },
              ],
            });
          });
      } else {
        this.btnDisabled = false;
      }
    },
    validateForm() {
      let inputsWrap = document.querySelectorAll(".apply-item");
      let validateResult = true;
      let len = inputsWrap.length;
      for (let i = 0; i < len; i++) {
        let curfield = this.formField[i];
        let curVal = "";
        let message = "";
        if (curfield.type == "image" || curfield.type == "video") {
          const percent = inputsWrap[i].querySelector(
            `input[name=${curfield.field}], select[name=${curfield.field}], textarea[name=${curfield.field}]`
          ).getAttribute('data-percent') || 0;

          if (percent < 100 && percent > 0) {
            this.setDialogDataAsync({
              message: '正在上传资料，请稍等...',
              btns: [
                {
                  text: "确认",
                },
              ],
            });
            return;
          }
        }

        if (curfield.type == "radio" || curfield.type == "checkbox") {
          let radios = inputsWrap[i].querySelectorAll(
            `input[name=${curfield.field}]`
          );
          curVal = this.getVal(radios, curfield.type);
        } else if (curfield.type == 'area') {
          curVal = this.provinceValue + '-' + this.cityValue + '-' + this.areaValue;
        } else if (curfield.type == 'array') {
            let arr = []
            curfield.list.forEach((val) => {
                if (val.value) {
                    arr.push(val.value)
                }
            })
            curVal = arr.join(',')
        } else {
          curVal = inputsWrap[i].querySelector(
            `input[name=${curfield.field}], select[name=${curfield.field}], textarea[name=${curfield.field}]`
          ).value;
        }
        if (curfield.isMust && curVal == "") {
          if (
            curfield.type == "select" ||
            curfield.type == "radio" ||
            curfield.type == "checkbox"
          ) {
            message = `请选择${curfield.name}`;
          } else if (curfield.type == "image" || curfield.type == "video") {
            message = `请上传${curfield.name}`;
          } else {
            message = `请填写${curfield.name}`;
          }
          this.setDialogDataAsync({
            message,
            btns: [
              {
                text: "确认",
              },
            ],
          });
          validateResult = false;
          break;
        } else if (
          curVal != "" &&
          curfield.regexp &&
          !eval(curfield.regexp).test(curVal)
        ) {
          this.setDialogDataAsync({
            message: `${curfield.name}格式填写错误`,
            btns: [
              {
                text: "确认",
              },
            ],
          });
          validateResult = false;
          break;
        } else {
          this.formData[curfield.field] = curVal;
        }
      }
      return validateResult;
    },
    // 获取单选框和复选框的值
    getVal(nodes, type) {
      let val = "";
      for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].checked) {
          val = !val ? nodes[i].value : `${val},${nodes[i].value}`;
        }
      }
      return val;
    },
    setDialogData(msg) {
      this.setDialogDataAsync({
        message: msg,
        btns: [
          {
            text: "确认",
          },
        ],
      });
    },
    goRule() {
        this.$router.push(`/rule?id=${this.aid}`);
    },
    getCityData() {
      axios.get('https://yunyingcdn.thecover.cn/o_1h2p81ek254fkpu19da1djjeru9.json').then(res => {
        if (res.status === 200) {
          const data = res.data || [];
          this.provinceData = data;
          this.handleProvince(); 
        }
      });
    },
    handleProvince() {
      const provinceData = this.provinceData;
      const provinceValue = this.provinceValue;
      provinceData.forEach(item => {
        if (item.value === provinceValue) {
          const child = item.children || [];
          this.cityData = child;
          this.cityValue = child[0] ? child[0].value : '';
          this.handleCity();
        }
      });
    },
    handleCity() {
      const cityData = this.cityData;
      const cityValue = this.cityValue;
      cityData.forEach(item => {
        if (item.value === cityValue) {
          const child = item.children || [];
          this.areaData = item.children;
          this.areaValue = child[0] ? child[0].value : '';
        }
      });
    },
    addInput(item, index) {
        item.list.splice(index + 1, 0, {
            value: ''
        })
    },
    removeInput(item, index) {
        item.list.splice(index, 1)
    },
    keyboardShow() {
        if (COVERAPP.Attribute.isApp() && COVERAPP.Attribute.isAndroid()) {
          document.querySelector('.home-wrapper').style.paddingBottom = '300px'
          document.activeElement.scrollIntoView(true)
        }
    },
    keyboardHidden() {
      if (COVERAPP.Attribute.isApp() && COVERAPP.Attribute.isAndroid()) {
        document.querySelector('.home-wrapper').style.paddingBottom = ''
        document.activeElement.scrollIntoView(false)
      }
    }
  },
};
</script>

<style lang="less" scoped>
.home-wrapper {
  overflow: hidden;
  min-height: 100vh;
}
.apply-top {
  margin-bottom: 0.2rem;
  .banner {
      position: relative;
      .rule-btn {
          position: absolute;
          right: 0;
          top: .5rem;
          font-size: 0.4rem;
          background-color: rgba(255, 255, 255, .6);
          line-height: 2.0em;
          padding: 0 .3rem;
          cursor: pointer;
      }
  }
  .title {
    text-align: center;
    font-size: 0.5rem;
    padding: 0.2rem 0.3rem;
    line-height: 1.5em;
    font-weight: normal;
  }
  .desc {
    font-size: 0.4rem;
    padding: 0 0.3rem;
    line-height: 1.3;
  }
  .apply-info {
    padding: 0.2rem 0.3rem;
    p {
      display: flex;
      align-items: center;
      padding: 0.05rem 0;
      span {
        font-size: 0.4rem;
        margin-right: 0.2rem;
        color: #444;
      }
      b {
        font-size: 0.28rem;
        font-weight: normal;
      }
    }
  }
}
.apply-wrap {
  padding: 0.2rem 0.3rem 0.5rem 0.3rem;
}
.apply-title {
  color: #000;
  font-size: 0.4rem;
  border-bottom: 1px solid #999;
  line-height: 2;
  font-weight: normal;
}
.apply-item {
  margin-top: 0.4rem;
  label {
    font-size: 0.4rem;
    span {
      color: red;
    }
  }
}
.apply-field {
  margin-top: 0.2rem;
  position: relative;
  .radio-wrapper,
  .checkbox-wrapper {
    label {
      display: block;
      margin-bottom: 0.15rem;
    }
  }
  .apply-field-type {
    width: 100%;
    appearance: none;
    font-size: 0.4rem;
    line-height: 1.3;
    padding: 0.2rem;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    border-radius: 0.05rem;
    outline: none;
    background-color: #fff;
    &.apply-field-textarea {
      height: 2rem;
    }
    &.apply-field-select {
      padding-right: 1rem;
    }
  }
  .input-wrapper {
    .item {
        display: flex;
        margin-bottom: .1852rem;
        .add, .remove {
            font-size: .8rem;
            color: #999;
            margin-left: .0926rem;
        }
        &:last-child {
            margin-bottom: 0;
        }
    }
    
  }
  .city-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 0.2rem;
    select {
      width: 33.33%;
      padding-right: .2rem;
    }
  }
  span {
    position: absolute;
    font-size: 0.4rem;
    right: 0.3rem;
    top: 0.28rem;
    color: #666;
  }
}
.apply-submit-btn {
  font-size: 0.4rem;
  background: #7070ef;
  color: #fff;
  width: 100%;
  letter-spacing: 0.1rem;
  line-height: 1rem;
  text-align: center;
  margin-top: 0.7rem;
  box-sizing: border-box;
  appearance: none;
  border: none;
}
.apply-my {
  position: fixed;
  width: 13vw;
  height: 13vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  box-shadow: 0 0 5vw rgba(0, 0, 0, 0.1);
  border-radius: 100vw;
  bottom: 25vw;
  right: 5vw;
  font-size: 3vw;
  color: #fe1226;
  font-weight: 500;
  text-decoration: none;
}
</style>